exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropzone .dz-preview.dz-image-preview{background:none}.dropzone .dz-preview .dz-image img{width:190px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/image-uploader/dropzone.scss
// module id = 3787
// module chunks = 0